import { useState } from "react";
import { BUTTON_STYLE, ERROR_MESSAGE_STYLE, HEADING_STYLE, INPUT_LABEL_STYLE, INPUT_STYLE, LABEL_STYLE, TEXTAREA_STYLE } from "../assets/constants";
import { IoWarningOutline } from "react-icons/io5"
import { apply } from "../services/job.services";
import SimpleAlert from "../alerts/SimpleAlert";
import { createPostFieldsValidator } from "../utilities/fieldsValidator";
import { useNavigate } from "react-router-dom";
export default function ApplyForm() {
    const [loading, setLoading] = useState(false);

    const [qualification, setQualification] = useState(null);
    const [institution, setInstitution] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [linkedInUrl, setLinkedInUrl] = useState(null);
    const [contact, setContact] = useState(null);
    const [city, setCity] = useState(null);
    const [goals, setGoals] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [paymentProof, setPaymentProof] = useState(null);
    const [transectionId, setTransectionId] = useState(null);

    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState({
        nameError: null,
        userNameError: null,
        emailError: null,
        qualificationError: null,
        contactError: null,
        cityError: null,
        addressError: null,
        paymentOptionError: null,
        institutionError: null,
        transectionIdError: null,
        idError: null,
    });
    const handleSubmit = async () => {
        setLoading(true)
        const isError = createPostFieldsValidator({
            name,
            email,
            contact,
            qualification,
            institution,
            city,
            selectedOption, 
            goals,
            transectionId,
            paymentProof
        });
        if (isError) { setLoading(false); return };
        const data = {
            name: name,
            email: email,
            contact: contact,
            linkedInUrl: linkedInUrl,
            qualification: qualification,
            institution: institution,
            city: city,
            basicKnowledge: selectedOption,
            goals: goals,
            transectionId: transectionId,
            trainingType: "adroid_b1_2023"
        };
        const formData = new FormData()
        formData.append("paymentProof", paymentProof)
        formData.append("body", JSON.stringify(data));

        const response = await apply(formData)
        if (response.status !== 200) {
            SimpleAlert("Error", "Error occured while processing, please try again", 'error', 1500)
        }
        SimpleAlert("Sucessfully", "Successfully registered for the training, furhter detials will be sent through email", 'success', 1500)
        setLoading(true)
        const timer = setTimeout(() => {
            setLoading(false);
            navigate("/")
        }, 1000); // Set the delay time in milliseconds (e.g., 5000 for 5 seconds)

        return () => clearTimeout(timer); // Clean up the timer on component unmount

    }
    const handleImageChange = (event) => {
        const imageMimeType = /image\/(png|jpg|jpeg)/i;

        const fileUploaded = event?.target?.files[0];
        if (!fileUploaded?.type?.match(imageMimeType)) {
            SimpleAlert("Image type is not valid", "", "error");
            return;
        }
        setPaymentProof(fileUploaded);
    }
    return (
        <>
            <div className="">
                <div className="bg-white  rounded-lg w-fit mx-auto">
                    <div className="py-5 px-3 md:px-5 space-y-5 select-none text-left">
                        <h1 className={`text-center ${HEADING_STYLE}`}>Android Crash Course Form</h1>
                        {/* name and email */}
                        <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-0 sm:gap-5">
                            {/* name */}
                            <div className="">
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_outlined"
                                        className={`${INPUT_STYLE} ${errorMessage.nameError && "border-red-600 text-red-600"}`}
                                        placeholder=" "
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        onBlur={() => {
                                            !name && setErrorMessage(prev => ({
                                                ...prev,
                                                nameError: "Name is required"
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.nameError && setErrorMessage(prev => ({
                                                ...prev,
                                                nameError: null
                                            }))
                                        }}

                                    />
                                    <label
                                        htmlFor="floating_outlined"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.nameError && "text-red-600"}`}

                                    >
                                        Name
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.nameError}</p>
                            </div>

                            {/* email */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="email"
                                        id="floating_email"
                                        value={email}
                                        placeholder=" "
                                        className={`${INPUT_STYLE} ${errorMessage.emailError && "border-red-600 text-red-600"}`}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onBlur={() => {
                                            !email && setErrorMessage(prev => ({
                                                ...prev,
                                                emailError: "Email is required"
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.emailError && setErrorMessage(prev => ({
                                                ...prev,
                                                emailError: null
                                            }))
                                        }}
                                    />
                                    <label
                                        htmlFor="floating_email"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.emailError && "text-red-600"}`}
                                    >
                                        Email
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.emailError}</p>

                            </div>

                        </div>



                        {/* phone and linknedin */}

                        <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-0 sm:gap-5">
                            {/* contact */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_contact"
                                        placeholder=" "
                                        value={contact}
                                        className={`${INPUT_STYLE} ${errorMessage.contactError && "border-red-600 text-red-600"}`}
                                        onChange={(e) => setContact(e.target.value)}
                                        onBlur={() => {
                                            !contact && setErrorMessage(prev => ({
                                                ...prev,
                                                contactError: "Contact is required"
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.contactError && setErrorMessage(prev => ({
                                                ...prev,
                                                contactError: null
                                            }))
                                        }}
                                    />
                                    <label
                                        htmlFor="floating_contact"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.contactError && "text-red-600"}`}
                                    >
                                        Contact
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.contactError}</p>

                            </div>
                            {/* linkedin url */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_linkedInUrl"
                                        placeholder=" "
                                        value={linkedInUrl}
                                        className={`${INPUT_STYLE}`}
                                        onChange={(e) => setLinkedInUrl(e.target.value)}

                                    />
                                    <label
                                        htmlFor="floating_linkedInUrl"
                                        className={`${INPUT_LABEL_STYLE} }`}
                                    >
                                        LinkedIn url
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{""}</p>

                            </div>
                        </div>



                        {/* Qualificactionn and dinstitutation */}
                        <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-0 sm:gap-5">
                            {/* Qualification */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_qualification"
                                        placeholder=" "
                                        value={qualification}
                                        className={`${INPUT_STYLE} ${errorMessage.qualificationError && "border-red-600 text-red-600"}`}
                                        onChange={(e) => setQualification(e.target.value)}
                                        onBlur={() => {
                                            !qualification && setErrorMessage(prev => ({
                                                ...prev,
                                                qualificationError: "This field is required"
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.qualificationError && setErrorMessage(prev => ({
                                                ...prev,
                                                qualificationError: null
                                            }))
                                        }}
                                    />
                                    <label
                                        htmlFor="floating_qualification"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.qualificationError && "text-red-600"}`}
                                    >
                                        Qualification
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.qualificationError}</p>

                            </div>
                            {/* Institution */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_Institution"
                                        placeholder=" "
                                        value={institution}
                                        className={`${INPUT_STYLE} ${errorMessage.institutionError && "border-red-600 text-red-600"}`}
                                        onChange={(e) => setInstitution(e.target.value)}
                                        onBlur={() => {
                                            !institution && setErrorMessage(prev => ({
                                                ...prev,
                                                institutionError: "This field is required."
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.institutionError && setErrorMessage(prev => ({
                                                ...prev,
                                                institutionError: null
                                            }))
                                        }}
                                    />
                                    <label
                                        htmlFor="floating_Institution"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.institutionError && "text-red-600"}`}
                                    >
                                        Institution
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.institutionError}</p>

                            </div>
                        </div>


                        {/* Current City */}

                        <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-0 sm:gap-5">
                            {/* Current City */}
                            <div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="floating_city"
                                        placeholder=" "
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        className={`${INPUT_STYLE} ${errorMessage.cityError && "border-red-600 text-red-600"}`}
                                        onBlur={() => {
                                            !city && setErrorMessage(prev => ({
                                                ...prev,
                                                cityError: "City Name is required"
                                            }))
                                        }}
                                        onClick={() => {
                                            errorMessage.cityError && setErrorMessage(prev => ({
                                                ...prev,
                                                cityError: null
                                            }))
                                        }}
                                    />
                                    <label
                                        htmlFor="floating_city"
                                        className={`${INPUT_LABEL_STYLE} ${errorMessage.cityError && "text-red-600"}`}
                                    >
                                        Current City
                                    </label>
                                </div>
                                <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.cityError}</p>

                            </div>
                            {/* right col */}

                        </div>
                        <div>
                            <div>
                                <label className={`${LABEL_STYLE} block mb-1`}>Do you have Basic programming knowledge and Object oriented programming concepts?</label>
                                <label className=" text-sm sm:text-md flex flex-row items-center text-gray-700 ">
                                    <input
                                        type="radio"
                                        className="mr-3 "
                                        value={"Yes"}
                                        checked={selectedOption === 'Yes'}
                                        onChange={(event) => {
                                            setSelectedOption(event.target.value)
                                        }}
                                    />
                                    Yes
                                </label>
                                <label className="text-sm sm:text-md flex flex-row items-center text-gray-700 ">
                                    <input
                                        type="radio"
                                        className="mr-3"
                                        value={"No"}
                                        checked={selectedOption === 'No'}
                                        onChange={(event) => {
                                            setSelectedOption(event.target.value)
                                        }} />
                                    No
                                </label>

                            </div>
                        </div>
                        <div>
                            <label className={`${LABEL_STYLE} block mb-1`}>What goals do you want to achieve by attending this Crash Course?</label>
                            <textarea className={`${TEXTAREA_STYLE}`}
                                rows={5}
                                placeholder={`Write you goals here...?`}
                                required
                                onChange={(e) => {
                                    setGoals(e.target.value);
                                }}
                            />
                        </div>

                        <div className="">
                            <h3 className={`${LABEL_STYLE} mb-1`}>Payment Procedure</h3>
                            <div className="bg-orange-200 py-2 px-2 md:p-3 rounded-lg md:flex  md:space-x-3">
                                <p className="flex items-center justify-center uppercase mb-2"><IoWarningOutline className="w-7 h-7 text-red-500" /> <span className="md:hidden">Warning</span></p>
                                <div className="text-sm sm:text-md space-y-2">
                                    <li>Please ensure that you have selected the correct payment option. Changing the payment option after submitting the form may not be possible.</li>
                                    <li>Before submiting the form make sure that you upload the payment proof screenshot. and add the Transection ID in the field </li>
                                </div>
                            </div>
                            <div className="bg-slate-100 rounded-lg p-5 mt-4">
                                <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-0 sm:gap-5">
                                    <div>
                                        <p className="text-md font-medium">Payment Option EasyPaisa
                                        </p>
                                        <p className="text-sm sm:text-md mt-1">
                                            Account Number: 03002284502

                                        </p>
                                    </div>
                                    <div>
                                        <p className="font-medium">Payment Option Jazzcash
                                        </p>
                                        <p className="text-sm sm:text-md mt-1">
                                            Account Number: 03072526008

                                        </p>
                                    </div>
                                </div>

                            </div>
                            <div className="grid sm:grid-cols-2 space-y-5 sm:space-y-5 sm:gap-5">
                                {/* screenshot */}
                                <div className="mt-4 flex flex-col items-center justify-center w-full h-auto  bg-slate-50  sm:rounded-lg sm:shadow-xl">
                                    <div className="mt-10 mb-10 text-center">
                                        <h2 className="text-md md:text-2xl font-semibold mb-2">Upload your files</h2>
                                        <p className="text-xs text-gray-500">Recommended formats are .png and .jpg</p>
                                    </div>
                                    <form className="relative w-4/5 h-32 max-w-xs mb-10 bg-white rounded-lg shadow-inner">
                                        <input type="file" id="file-upload" className="hidden"
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="file-upload"
                                            className="z-20 flex flex-col-reverse items-center justify-center w-full h-full cursor-pointer"
                                        >
                                            <p className="z-10 text-xs font-light text-center text-gray-500">Select File</p>
                                            <svg className="z-10 w-8 h-8 text-indigo-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path>
                                            </svg>
                                        </label>
                                    </form>
                                </div>
                                <div className="">
                                    {paymentProof && <img
                                        src={URL.createObjectURL(paymentProof)}
                                        className="w-full h-72 rounded-lg"
                                    />}
                                </div>

                            </div>
                            {/* transection if */}
                            <div className="mt-10 grid sm:grid-cols-2 col-span-1">

                                <div >
                                    <div className="relative">
                                        <input
                                            type="text"
                                            id="floating_transectionId"
                                            placeholder=" "
                                            value={transectionId}
                                            className={`${INPUT_STYLE} ${errorMessage.transectionIdError && "border-red-600 text-red-600"}`}
                                            onChange={(e) => setTransectionId(e.target.value)}
                                            onBlur={() => {
                                                !city && setErrorMessage(prev => ({
                                                    ...prev,
                                                    transectionIdError: "Transection Id is Required"
                                                }))
                                            }}
                                            onClick={() => {
                                                errorMessage.transectionIdError && setErrorMessage(prev => ({
                                                    ...prev,
                                                    transectionIdError: null
                                                }))
                                            }}

                                        />
                                        <label
                                            htmlFor="floating_transectionId"
                                            className={`${INPUT_LABEL_STYLE} }`}
                                        >
                                            Transection Id
                                        </label>
                                    </div>
                                    <p className={`${ERROR_MESSAGE_STYLE}`}>{errorMessage.transectionIdError}</p>

                                </div>
                            </div>
                        </div>
                        <div className="flex justify-between items-center">
                            <button className={`${BUTTON_STYLE} px-5 space-x-2 font-medium flex items-center`} onClick={handleSubmit}>
                                <span>Submit</span>
                                {loading && <div class="w-6 h-6 rounded-full animate-spin
                    border-y border-dashed border-yellow-500 border-t-transparent"></div>}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}